import React from 'react'
import { IoCloseOutline } from "react-icons/io5";
import { motion } from 'framer-motion'




const CODModal = ({setModal, data}) => {

  return (
    <motion.div 
     initial={{ scale: 0.5, opacity: 0 }}
     animate={{ scale: 1, opacity: [0.1, 0.1, 0.5, 0.7, 1] }}
     transition={{ duration: 0.7, ease: "easeIn" }}
     exit={{ opacity: 0, transition: { duration: 1.5, ease: "easeIn" } }}
     className='mb-10 w-full h-[95vh] z-50 bg-white pt-5 shadow-md rounded-xl md:pt-6 lg:-mt-24 mx-auto'>

      {/* TITLE */}
       <div className='flex items-start justify-between w-full px-3 md:px-5 md:items-center lg:px-7'>
          <p className='text-[11px] text-[#101828] font-semibold w-[75%] md:text-[12px] lg:text-sm xl:text-base'>
              {data.name}
          </p>
          <IoCloseOutline onClick={()=>setModal(false)} className='text-xl lg:text-2xl xl:text-3xl' />
       </div>

       {/* HORIZONTAL LINE */}
       <div className='w-full mt-2.5 bg-[#DDE1E6] border-[1px] border-dashed lg:mt-3.5'></div>

       {/* CONTENT */}
        <div className='px-3 pb-5 mt-2.5 w-full overflow-y-auto max-h-[81.5vh] md:mt-3 md:px-5 md:max-h-[80vh] lg:max-h-[78vh] lg:px-7 xl:mt-4 xl:max-h-[77.5vh]'>
           <div className='w-full'>
               <p className='text-[11px] text-[#25A249] font-semibold pt-1 md:text-[12px] md:leading-5 lg:text-[13px] lg:leading-[22px] xl:text-[15px] xl:leading-6'>
                    INSTRUCTION: {data.instruction}
               </p>

               <div className='pt-3 xl:pt-5'>
                   <p className='text-[10px] text-[#101828] font-normal md:text-[12px] md:leading-5 lg:text-[13px] lg:leading-[22px] xl:text-[15px] xl:leading-6'>
                       {data.content}
                   </p>
               </div>

            </div>

        </div>

        {/* CLOSE BUTTON */}
        <div className='flex items-center justify-end w-full mt-2.5 px-3 md:px-5 lg:px-7 lg:mt-3.5 xl:mt-4'>
              <div onClick={()=>setModal(false)}
              className='flex items-center justify-center w-[75px] h-7 rounded-md bg-[#25A249] text-white cursor-pointer md:w-[90px] md:h-8 xl:h-10 xl:w-28 xl:rounded-lg'>
                  <p className='text-[11px] font-normal md:text-xs xl:text-base'>Close</p>
                  <IoCloseOutline  className='text-base ml-[6px] md:text-lg md:ml-2 xl:text-2xl' />
              </div>
        </div>

    </motion.div>
  )
}

export default CODModal
